import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

interface ActiveCustomRule {
  id: string
  startDate?: string
  endDate?: string
}

type Response = paths['/api/lux-loyalty/custom-rules']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyActiveCustomRules(): Promise<Array<ActiveCustomRule>> {
  const response = await requestUtils.get<Response>('/api/lux-loyalty/custom-rules?status=active', {
    excludeBrand: true,
  })
  return response.result.customRules
}

export default requestLoyaltyActiveCustomRules
